
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire37b7"];
var parcelRegister = parcelRequire.register;
parcelRegister("7ecAu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54339ad51eb86f63$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $61RDg = parcelRequire("61RDg");

var $dsN6L = parcelRequire("dsN6L");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $koa2c = parcelRequire("koa2c");

var $4ucu0 = parcelRequire("4ucu0");
var $54339ad51eb86f63$var$_excluded = [
    "appearance",
    "className",
    "elemAfterInput",
    "elemBeforeInput",
    "isCompact",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "isReadOnly",
    "isRequired",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseDown",
    "placeholder",
    "testId",
    "width"
];
function $54339ad51eb86f63$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $54339ad51eb86f63$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $54339ad51eb86f63$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $54339ad51eb86f63$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $54339ad51eb86f63$var$analyticsParams = {
    componentName: "textField",
    packageName: "@atlaskit/textfield",
    packageVersion: "6.7.2"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ var $54339ad51eb86f63$var$Textfield = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(props, ref) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "standard" : _props$appearance, className = props.className, elemAfterInput = props.elemAfterInput, elemBeforeInput = props.elemBeforeInput, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onMouseDown = props.onMouseDown, placeholder = props.placeholder, testId = props.testId, width = props.width, spreadProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(props, $54339ad51eb86f63$var$_excluded);
    var inputRef = (0, $91i6m.useRef)(null);
    var handleOnFocus = (0, $koa2c.usePlatformLeafEventHandler)($54339ad51eb86f63$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: "focused"
    }, $54339ad51eb86f63$var$analyticsParams));
    var handleOnBlur = (0, $koa2c.usePlatformLeafEventHandler)($54339ad51eb86f63$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: "blurred"
    }, $54339ad51eb86f63$var$analyticsParams));
    var handleOnMouseDown = (0, $91i6m.useCallback)(function(event) {
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        var target = event.target;
        if (target.tagName !== "INPUT") event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    var setInputRef = (0, $91i6m.useCallback)(function(inputElement) {
        inputRef.current = inputElement;
        if (!ref) return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(ref) === "object") ref.current = inputElement;
        if (typeof ref === "function") ref(inputElement);
    }, [
        ref
    ]);
    var containerStyles = (0, $91i6m.useMemo)(function() {
        return (0, $4ucu0.containerStyles)(appearance, width);
    }, [
        appearance,
        width
    ]);
    var inputStyle = (0, $4ucu0.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ (0, $lPOF7.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && "".concat(testId, "-container"),
        onMouseDown: handleOnMouseDown,
        css: containerStyles,
        className: className
    }, elemBeforeInput, (0, $lPOF7.jsx)("input", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, spreadProps, {
        "aria-invalid": isInvalid ? isInvalid : undefined,
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    })), elemAfterInput));
});
var $54339ad51eb86f63$export$2e2bcd8739ae039 = $54339ad51eb86f63$var$Textfield;

});
parcelRegister("4ucu0", function(module, exports) {

$parcel$export(module.exports, "containerStyles", function () { return $3443a59df996b78f$export$5972a68b6e54f38f; });
$parcel$export(module.exports, "inputStyles", function () { return $3443a59df996b78f$export$3eeb47dc8e6249d9; });

var $dsN6L = parcelRequire("dsN6L");

var $f1k1y = parcelRequire("f1k1y");

var $dSVKJ = parcelRequire("dSVKJ");

var $jj2Nq = parcelRequire("jj2Nq");
function $3443a59df996b78f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3443a59df996b78f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3443a59df996b78f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3443a59df996b78f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3443a59df996b78f$var$backgroundColor = {
    standard: "var(--ds-background-input, ".concat((0, $jj2Nq.N10), ")"),
    subtle: "transparent",
    none: "transparent"
};
var $3443a59df996b78f$var$backgroundColorFocus = {
    standard: "var(--ds-background-input-pressed, ".concat((0, $jj2Nq.N0), ")"),
    subtle: "var(--ds-background-input-pressed, ".concat((0, $jj2Nq.N0), ")"),
    none: "transparent"
};
var $3443a59df996b78f$var$backgroundColorHover = {
    standard: "var(--ds-background-input-hovered, ".concat((0, $jj2Nq.N30), ")"),
    subtle: "var(--ds-background-input-hovered, ".concat((0, $jj2Nq.N30), ")"),
    none: "transparent"
};
var $3443a59df996b78f$var$borderColor = {
    standard: "var(--ds-border-input, ".concat((0, $jj2Nq.N100), ")"),
    subtle: "transparent",
    none: "transparent"
};
var $3443a59df996b78f$var$borderColorFocus = {
    standard: "var(--ds-border-focused, ".concat((0, $jj2Nq.B200), ")"),
    subtle: "var(--ds-border-focused, ".concat((0, $jj2Nq.B200), ")"),
    none: "transparent"
};
var $3443a59df996b78f$var$borderColorHover = {
    standard: "var(--ds-border-input, ".concat((0, $jj2Nq.N100), ")"),
    subtle: "var(--ds-border-input, transparent)",
    none: "transparent"
};
var $3443a59df996b78f$var$getContainerTextBgAndBorderColor = function getContainerTextBgAndBorderColor(appearance) {
    return {
        backgroundColor: $3443a59df996b78f$var$backgroundColor[appearance],
        borderColor: $3443a59df996b78f$var$borderColor[appearance],
        color: "var(--ds-text, ".concat((0, $jj2Nq.N900), ")"),
        cursor: "text",
        "&:hover:not([data-disabled])": {
            backgroundColor: $3443a59df996b78f$var$backgroundColorHover[appearance],
            borderColor: $3443a59df996b78f$var$borderColorHover[appearance]
        },
        "&:focus-within:not([data-disabled])": {
            backgroundColor: $3443a59df996b78f$var$backgroundColorFocus[appearance],
            borderColor: $3443a59df996b78f$var$borderColorFocus[appearance],
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $3443a59df996b78f$var$borderColorFocus[appearance])
        },
        "&[data-disabled]": $3443a59df996b78f$var$_objectSpread({
            color: "var(--ds-text-disabled, ".concat((0, $jj2Nq.N70), ")"),
            cursor: "not-allowed"
        }, appearance === "standard" && {
            backgroundColor: "var(--ds-background-disabled, ".concat((0, $jj2Nq.N10), ")"),
            borderColor: "var(--ds-background-disabled, ".concat((0, $jj2Nq.N10), ")")
        }),
        "&[data-invalid], &[data-invalid]:hover": {
            borderColor: "var(--ds-border-danger, ".concat((0, $jj2Nq.R400), ")"),
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-danger, ".concat((0, $jj2Nq.R400), ")"))
        },
        "&[data-invalid]:focus-within": {
            backgroundColor: "var(--ds-background-input-pressed, ".concat((0, $jj2Nq.N0), ")"),
            borderColor: "var(--ds-border-focused, ".concat((0, $jj2Nq.B200), ")"),
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-focused, ".concat((0, $jj2Nq.B200), ")"))
        },
        "@media screen and (-ms-high-contrast: active)": {
            "&[data-invalid]:focus-within": {
                borderColor: "Highlight"
            },
            "&:focus-within": {
                borderColor: "Highlight"
            },
            "&[data-disabled]": {
                borderColor: "GrayText"
            }
        }
    };
};
var $3443a59df996b78f$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
var $3443a59df996b78f$var$getMaxWidth = function getMaxWidth(width) {
    return !width ? "100%" : width in $3443a59df996b78f$var$widthMap ? $3443a59df996b78f$var$widthMap[width] : +width;
};
var $3443a59df996b78f$export$5972a68b6e54f38f = function containerStyles(appearance, width) {
    return $3443a59df996b78f$var$_objectSpread($3443a59df996b78f$var$_objectSpread($3443a59df996b78f$var$_objectSpread({
        alignItems: "center"
    }, $3443a59df996b78f$var$getContainerTextBgAndBorderColor(appearance)), {}, {
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)"
    }, appearance !== "none" ? {
        padding: "var(--ds-border-width, 1px)".concat(" 0")
    } : {}), {}, {
        borderStyle: appearance === "none" ? "none" : "solid",
        boxSizing: "border-box",
        display: "flex",
        flex: "1 1 100%",
        font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
        justifyContent: "space-between",
        maxWidth: $3443a59df996b78f$var$getMaxWidth(width),
        overflow: "hidden",
        transition: "background-color 0.2s ease-in-out, border-color 0.2s ease-in-out",
        wordWrap: "break-word",
        verticalAlign: "top",
        pointerEvents: "auto"
    });
};
var $3443a59df996b78f$export$3eeb47dc8e6249d9 = function inputStyles() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({
        backgroundColor: "transparent",
        border: 0,
        boxSizing: "border-box",
        color: "inherit",
        cursor: "inherit",
        font: (0, $f1k1y.fg)("platform_design_system_team_safari_input_fix") ? 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)' : 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
        minWidth: "0",
        outline: "none",
        width: "100%",
        "&[data-monospaced]": (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({
            fontFamily: 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)'
        }, (0, $dSVKJ.media).above.xs, {
            // Reapply the monospaced font family as the font declaration in a breakpoint on the root will override it otherwise
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontFamily: (0, $f1k1y.fg)("platform_design_system_team_safari_input_fix") ? 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)' : undefined
        }),
        "&[data-compact]": {
            padding: (0, $f1k1y.fg)("platform_design_system_team_safari_input_fix") ? "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)") : "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-075, 6px)")
        },
        "&:not([data-compact])": {
            padding: (0, $f1k1y.fg)("platform_design_system_team_safari_input_fix") ? "var(--ds-space-075, 6px)".concat(" ", "var(--ds-space-075, 6px)") : "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-075, 6px)")
        },
        "&[disabled]": {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: "var(--ds-text-disabled, ".concat((0, $jj2Nq.N70), ")")
        },
        // Hide the clear indicator on Edge (Windows only)
        "&::-ms-clear": {
            display: "none"
        },
        "&:invalid": {
            boxShadow: "none"
        },
        "&:placeholder-shown": {
            textOverflow: "ellipsis"
        },
        "&::placeholder": {
            color: "var(--ds-text-subtlest, ".concat((0, $jj2Nq.N200), ")"),
            "&:disabled": {
                color: "var(--ds-text-disabled, ".concat((0, $jj2Nq.N70), ")")
            }
        },
        "@media screen and (-ms-high-contrast: active)": {
            "&[disabled]": {
                color: "GrayText"
            }
        }
    }, (0, $dSVKJ.media).above.xs, {
        font: (0, $f1k1y.fg)("platform_design_system_team_safari_input_fix") ? 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)' : undefined,
        "&[data-compact]": {
            padding: (0, $f1k1y.fg)("platform_design_system_team_safari_input_fix") ? "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-075, 6px)") : undefined
        },
        "&:not([data-compact])": {
            padding: (0, $f1k1y.fg)("platform_design_system_team_safari_input_fix") ? "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-075, 6px)") : undefined
        }
    });
};

});
parcelRegister("jj2Nq", function(module, exports) {

$parcel$export(module.exports, "R400", function () { return $e0e1f5f21c1c3c18$export$2010d0fb4295b346; });
$parcel$export(module.exports, "B200", function () { return $e0e1f5f21c1c3c18$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $e0e1f5f21c1c3c18$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $e0e1f5f21c1c3c18$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N30", function () { return $e0e1f5f21c1c3c18$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N70", function () { return $e0e1f5f21c1c3c18$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N100", function () { return $e0e1f5f21c1c3c18$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $e0e1f5f21c1c3c18$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N900", function () { return $e0e1f5f21c1c3c18$export$fbda843f0a27fe96; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $e0e1f5f21c1c3c18$export$4b84fd0e2c617bd = "#FFEBE6";
var $e0e1f5f21c1c3c18$export$b34b069eff244586 = "#FFBDAD";
var $e0e1f5f21c1c3c18$export$be802dd0d8b57f35 = "#FF8F73";
var $e0e1f5f21c1c3c18$export$60847d42f9da92a6 = "#FF7452";
var $e0e1f5f21c1c3c18$export$4a7404f376229999 = "#FF5630";
var $e0e1f5f21c1c3c18$export$2010d0fb4295b346 = "#DE350B";
var $e0e1f5f21c1c3c18$export$2837b5a1a71d5c02 = "#BF2600";
var $e0e1f5f21c1c3c18$export$8d9596b529bbb9cf = "#FFFAE6";
var $e0e1f5f21c1c3c18$export$41060a744ab0b7ae = "#FFF0B3";
var $e0e1f5f21c1c3c18$export$1cc05bbbf340e559 = "#FFE380";
var $e0e1f5f21c1c3c18$export$5aae31392d72caaa = "#FFC400";
var $e0e1f5f21c1c3c18$export$c6930421db9fa514 = "#FFAB00";
var $e0e1f5f21c1c3c18$export$59619663aa6500fb = "#FF991F";
var $e0e1f5f21c1c3c18$export$874739ea9e379ab6 = "#FF8B00";
var $e0e1f5f21c1c3c18$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $e0e1f5f21c1c3c18$export$69a3bf21b9686c2b = "#ABF5D1";
var $e0e1f5f21c1c3c18$export$afbce1382ec95f73 = "#79F2C0";
var $e0e1f5f21c1c3c18$export$747d86715d4175de = "#57D9A3";
var $e0e1f5f21c1c3c18$export$940e1f69e873f202 = "#36B37E";
var $e0e1f5f21c1c3c18$export$a49394138f7b8e85 = "#00875A";
var $e0e1f5f21c1c3c18$export$6fa04827ac68a4fb = "#006644";
var $e0e1f5f21c1c3c18$export$226de0355ed012f8 = "#DEEBFF";
var $e0e1f5f21c1c3c18$export$8c13c2ee36917869 = "#B3D4FF";
var $e0e1f5f21c1c3c18$export$ecfc1dff386a3e7a = "#4C9AFF";
var $e0e1f5f21c1c3c18$export$215b7063051591f1 = "#2684FF";
var $e0e1f5f21c1c3c18$export$e62e8919cca44969 = "#0065FF";
var $e0e1f5f21c1c3c18$export$b3de0ae08da2ce64 = "#0052CC";
var $e0e1f5f21c1c3c18$export$a6ee3d71bc067634 = "#0747A6";
var $e0e1f5f21c1c3c18$export$67f15409e87642a1 = "#669DF1";
var $e0e1f5f21c1c3c18$export$f0539dbc42dbb067 = "#8FB8F6";
var $e0e1f5f21c1c3c18$export$363e4475840015bb = "#EAE6FF";
var $e0e1f5f21c1c3c18$export$4b0a4417ed59760f = "#C0B6F2";
var $e0e1f5f21c1c3c18$export$6011520a64d9a187 = "#998DD9";
var $e0e1f5f21c1c3c18$export$a7175d4e9206bc80 = "#8777D9";
var $e0e1f5f21c1c3c18$export$b48405b95304b5a1 = "#6554C0";
var $e0e1f5f21c1c3c18$export$c71e4279dd54a18d = "#5243AA";
var $e0e1f5f21c1c3c18$export$147899de772240ec = "#403294";
var $e0e1f5f21c1c3c18$export$2cf711fe14c66f06 = "#E6FCFF";
var $e0e1f5f21c1c3c18$export$7a8f4d33f6f9772c = "#B3F5FF";
var $e0e1f5f21c1c3c18$export$776c9c497ef08533 = "#79E2F2";
var $e0e1f5f21c1c3c18$export$69cb3ca10c1e330e = "#00C7E6";
var $e0e1f5f21c1c3c18$export$9dc1ef0f3f48059b = "#00B8D9";
var $e0e1f5f21c1c3c18$export$7c835c78b6fcdef8 = "#00A3BF";
var $e0e1f5f21c1c3c18$export$6036577f95c3877e = "#008DA6";
var $e0e1f5f21c1c3c18$export$29a4f05edc054374 = "#FFFFFF";
var $e0e1f5f21c1c3c18$export$e655ef011c4aa1a2 = "#FAFBFC";
var $e0e1f5f21c1c3c18$export$9fdfb749e33cdf97 = "#F4F5F7";
var $e0e1f5f21c1c3c18$export$3e51e8f1440314ba = "#EBECF0";
var $e0e1f5f21c1c3c18$export$1ce2d1575d444ceb = "#DFE1E6";
var $e0e1f5f21c1c3c18$export$8754fc7e6d8b3000 = "#C1C7D0";
var $e0e1f5f21c1c3c18$export$c2e91cbeada39b8b = "#B3BAC5";
var $e0e1f5f21c1c3c18$export$5f71e19f3a7ad9de = "#A5ADBA";
var $e0e1f5f21c1c3c18$export$eaa8c8a70ac22806 = "#97A0AF";
var $e0e1f5f21c1c3c18$export$7c87d337fb91a97d = "#8993A4";
var $e0e1f5f21c1c3c18$export$d6447c357493214f = "#7A869A";
var $e0e1f5f21c1c3c18$export$f563ee71e9ee74cd = "#6B778C";
var $e0e1f5f21c1c3c18$export$e2ef2124cf4024b1 = "#5E6C84";
var $e0e1f5f21c1c3c18$export$eece5f492e429f08 = "#505F79";
var $e0e1f5f21c1c3c18$export$c39c0fe0f26207ae = "#42526E";
var $e0e1f5f21c1c3c18$export$7090862dc3038a9f = "#344563";
var $e0e1f5f21c1c3c18$export$ad0bacf983b7ddaa = "#253858";
var $e0e1f5f21c1c3c18$export$7d61b15e0da132af = "#172B4D";
var $e0e1f5f21c1c3c18$export$fbda843f0a27fe96 = "#091E42";
var $e0e1f5f21c1c3c18$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $e0e1f5f21c1c3c18$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $e0e1f5f21c1c3c18$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $e0e1f5f21c1c3c18$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $e0e1f5f21c1c3c18$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $e0e1f5f21c1c3c18$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $e0e1f5f21c1c3c18$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $e0e1f5f21c1c3c18$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $e0e1f5f21c1c3c18$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $e0e1f5f21c1c3c18$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $e0e1f5f21c1c3c18$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $e0e1f5f21c1c3c18$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $e0e1f5f21c1c3c18$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $e0e1f5f21c1c3c18$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $e0e1f5f21c1c3c18$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $e0e1f5f21c1c3c18$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $e0e1f5f21c1c3c18$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $e0e1f5f21c1c3c18$export$2f6319cf7d736c2a = "#E6EDFA";
var $e0e1f5f21c1c3c18$export$95126bc8884d6634 = "#DCE5F5";
var $e0e1f5f21c1c3c18$export$8338d8c35d44ff1 = "#CED9EB";
var $e0e1f5f21c1c3c18$export$5368d76ae4fbbda7 = "#B8C7E0";
var $e0e1f5f21c1c3c18$export$9f0a771d16ec8d36 = "#ABBBD6";
var $e0e1f5f21c1c3c18$export$abcf8c38338b4aa5 = "#9FB0CC";
var $e0e1f5f21c1c3c18$export$97e81faa16a182c7 = "#8C9CB8";
var $e0e1f5f21c1c3c18$export$bfe21c59123ecf33 = "#7988A3";
var $e0e1f5f21c1c3c18$export$ee82aa2ea6a1558 = "#67758F";
var $e0e1f5f21c1c3c18$export$682927c6ed76be02 = "#56637A";
var $e0e1f5f21c1c3c18$export$91fd9994c5be9757 = "#455166";
var $e0e1f5f21c1c3c18$export$d281fbfe3cff2df6 = "#3B475C";
var $e0e1f5f21c1c3c18$export$3902c91d8b98a753 = "#313D52";
var $e0e1f5f21c1c3c18$export$8e8133c1ba5845b5 = "#283447";
var $e0e1f5f21c1c3c18$export$33ff357f6620b39 = "#202B3D";
var $e0e1f5f21c1c3c18$export$633847cf062b69e0 = "#1B2638";
var $e0e1f5f21c1c3c18$export$9776a6e503bdbf76 = "#121A29";
var $e0e1f5f21c1c3c18$export$6c813d5160dff5db = "#0E1624";
var $e0e1f5f21c1c3c18$export$3d4f271a500072a = "#0D1424";
var $e0e1f5f21c1c3c18$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $e0e1f5f21c1c3c18$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $e0e1f5f21c1c3c18$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $e0e1f5f21c1c3c18$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $e0e1f5f21c1c3c18$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $e0e1f5f21c1c3c18$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $e0e1f5f21c1c3c18$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $e0e1f5f21c1c3c18$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $e0e1f5f21c1c3c18$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $e0e1f5f21c1c3c18$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $e0e1f5f21c1c3c18$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $e0e1f5f21c1c3c18$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $e0e1f5f21c1c3c18$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $e0e1f5f21c1c3c18$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $e0e1f5f21c1c3c18$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $e0e1f5f21c1c3c18$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $e0e1f5f21c1c3c18$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $e0e1f5f21c1c3c18$export$d2adc5dedf09fced = "#292A2E";
var $e0e1f5f21c1c3c18$export$f51762073d2bb381 = "#94C748";
var $e0e1f5f21c1c3c18$export$95e26d54def96891 = "#B3DF72";

});




//# sourceMappingURL=MultiFactorPage.563d3fae.js.map
